<div class="tr layout-row layout-align-start-center" (click)="onViewRouteTasks();$event.stopPropagation();">
  <!--Agent-->
  <div class="td medium layout-row layout-align-start-center flex-20 text-ellipsis">

    <app-user-avatar [user]="agentRouteScore.agentReference"
                     [url]="agentRouteScore.agentReference.avatarUrl"
                     size="xsmall"
                     class="margin-left-5 margin-right-5">
    </app-user-avatar>

    <div class="layout-column">

      <div class="layout-row layout-align-start-center">
        <app-agent-itinerary-link [linkToAgentView]="true"
                                  [agentName]="agentRouteScore.agentReference.firstName + ' ' + agentRouteScore.agentReference.lastName"
                                  [agentId]="agentRouteScore.agentReference.id"
                                  [isShowCopyButton]="true">
        </app-agent-itinerary-link>

        <bringoz-icon class="margin-left-5"
                      *ngIf="agentRouteScore.agentBranchReferences?.length"
                      iconName="branch" fill="#7E7E7E" classSize="md"
                      [ngbTooltip]="tooltipTmpl" placement="top" openDelay="300" triggers="hover"
                      container="body"></bringoz-icon>
        <ng-template #tooltipTmpl>
          <div class="layout-column">
              <span *ngFor="let branch of agentRouteScore.agentBranchReferences">
                {{branch.name}}
              </span>
          </div>
        </ng-template>

        <app-agent-location class="margin-left-5"
                            *ngIf="agentRouteScore.agentLastKnownLocation.deviceReference"
                            [location]="agentRouteScore.agentLastKnownLocation.coordinates"
                            direction="right"
                            [showText]="false"
                            [locationTrackingApproval]="agentRouteScore?.agentLocationTrackingApproval"
                            [gpsStatus]="agentRouteScore.agentLastKnownLocation.deviceReference?.gpsStatus"
                            [gpsPermission]="agentRouteScore.agentLastKnownLocation.deviceReference?.gpsPermission"
                            [lastUpdate]="agentRouteScore.agentLastKnownLocation.updatedAt">
        </app-agent-location>
      </div>

      <div class="layout-row layout-align-start-center">
        <app-bringoz-tags *ngIf="agentRouteScore.agentReference.tags"
                          [tags]="agentRouteScore.agentReference.tags"
                          [tagType]="tagTypes.Agent"
                          [isShowTagDescriptions]="true"
                          backgroundColor="transparent"
                          color="#7E7E7E"
                          class="margin-right-5"
                          maxTags="1">
        </app-bringoz-tags>

        <span *ngIf="agentRouteScore.agentReference.externalId"
              class="br-body-1 text-ellipsis font-weight-400 gray-102">
          {{agentRouteScore.agentReference.externalId}}
        </span>

      </div>
    </div>

  </div>

  <!--Start Time-->
  <div class="td xsmall layout-column flex-10 text-ellipsis">
    <div class="br-body-1 font-weight-600 layout-row layout-align-start-center"
         [ngbTooltip]="agentRouteScore.startTime || !!geoEnterTime ?  actualStartTime : null" openDelay="300"
         triggers="hover" container="body"
         [ngClass]="{'green': !!geoEnterTime ? geoEnterTime?.timeStamp === agentRouteScore.planedStartTime : agentRouteScore.startTime === agentRouteScore.planedStartTime,
           'red': geoEnterTime ?  geoEnterTime?.timeStamp !== agentRouteScore.planedStartTime : agentRouteScore.startTime !== agentRouteScore.planedStartTime}">
      <span class="margin-right-5" translate>A</span>
      <span *ngIf="!geoEnterTime">{{agentRouteScore | bringozTime: 'startTime'}}</span>
      <span *ngIf="!!geoEnterTime">{{geoEnterTime | bringozTime: 'timeStamp'}}</span>
    </div>
    <!--    <span class="margin-left-5 margin-right-5">/</span>-->

    <div class="br-body-1 font-weight-400 layout-row layout-align-start-center margin-top-5"
         [ngbTooltip]="plannedStartTime"
         openDelay="300"
         triggers="hover"
         container="body">
      <span class="margin-right-5" translate>PL</span>
      <span>{{agentRouteScore | bringozTime: 'planedStartTime'}}</span>
    </div>

    <ng-template #actualStartTime>
      <span *ngIf="!geoEnterTime">{{agentRouteScore | bringozTime: 'startTime'}} {{'Actual Start Time' | translate}}
        ({{'Manual' | translate}})</span>
      <span *ngIf="!!geoEnterTime">{{geoEnterTime | bringozTime: 'timeStamp'}} {{'Actual Start Time' | translate}}
        ({{'Passive' | translate}})</span>
    </ng-template>

    <ng-template #plannedStartTime>
      <span>{{agentRouteScore | bringozTime: 'planedStartTime'}} {{'Planned Start Time' | translate}}</span>
    </ng-template>
  </div>

  <!--End Time-->
  <div class="td xsmall layout-column flex-10 text-ellipsis">
    <span class="br-body-1 font-weight-600"
          [ngbTooltip]="agentRouteScore.endTime || geoExitTime ?  actualEndTime : null" openDelay="300" triggers="hover"
          container="body"
          [ngClass]="{'green': !!geoExitTime ? geoExitTime?.timeStamp === agentRouteScore.planedEndTime : agentRouteScore.endTime === agentRouteScore.planedEndTime,
           'red': !!geoExitTime ?  geoExitTime?.timeStamp !== agentRouteScore.planedEndTime : agentRouteScore.endTime !== agentRouteScore.planedEndTime}">
      <span class="margin-right-5" translate>A</span>
      <span *ngIf="!geoExitTime">{{agentRouteScore | bringozTime: 'endTime'}}</span>
      <span *ngIf="!!geoExitTime">{{geoExitTime | bringozTime: 'timeStamp'}}</span>
    </span>
    <!--    <span class="margin-left-5 margin-right-5">/</span>-->
    <div class="br-body-1 font-weight-400 layout-row layout-align-start-center margin-top-5"
         [ngbTooltip]="plannedEndTime" openDelay="300" triggers="hover" container="body">
      <span class="margin-right-5" translate>PL</span>
      <span>
              {{agentRouteScore | bringozTime: 'planedEndTime'}}
      </span>
    </div>

    <ng-template #actualEndTime>
      <span *ngIf="!geoExitTime">{{agentRouteScore | bringozTime: 'endTime'}} {{'Actual End Time' | translate}}
        ({{'Manual' | translate}})</span>
      <span *ngIf="!!geoExitTime">{{geoExitTime | bringozTime: 'timeStamp'}} {{'Actual End Time' | translate}}
        ({{'Passive' | translate}})</span>
    </ng-template>

    <ng-template #plannedEndTime>
      <span>{{agentRouteScore | bringozTime: 'planedEndTime'}} {{'Planned End Time' | translate}}</span>
    </ng-template>

  </div>

  <!--Missed Tasks-->
  <div class="td xsmall layout-row flex-10 text-ellipsis">
    <span class="br-body-1 font-weight-400 primary-100">{{agentRouteScore.missingStops}}</span>
  </div>

  <!--Hours-->
  <div class="td xsmall layout-row flex-10 text-ellipsis">
    <span
            class="br-body-1 font-weight-400 primary-100">{{agentRouteScore.workingHoursInMillis | bringozTimeConvert: true }}</span>
  </div>

  <!--Sequence-->
  <div class="td large layout-row layout-align-start-center flex">
    <app-agent-sequence-score class="flex" [agentRouteScore]="agentRouteScore"></app-agent-sequence-score>
  </div>

  <!--Route Score-->
  <div class="td xsmall layout-row layout-align-start-center flex-10 text-ellipsis full-height"
       [ngbTooltip]="scoreTooltip" openDelay="300" triggers="hover" container="body">
    <span *ngIf="agentRouteScore.routeScore >= 0"
          [class.total-performance-metric]="agentRouteScore.routeScore >= 0"
          [class.good-score]="agentRouteScore.routeScore >= 80"
          [class.average-score]="agentRouteScore.routeScore > 60 && agentRouteScore.routeScore < 80"
          [class.bad-score]="agentRouteScore.routeScore <= 60"
          class="br-body-1 font-weight-600">{{agentRouteScore.routeScore}} %
    </span>
    <ng-template #scoreTooltip>
      <div class="layout-column">
        <div *ngIf="agentRouteScore.startTimeCorrectnessScore >=0" class="layout-row layout-align-start-center">
          <span class="primary-100 br-body-2 font-weight-400" translate>Start time scoring</span>
          <span class="br-body-1 font-weight-600 margin-left-10"
                [class.good-score]="agentRouteScore.startTimeCorrectnessScore >= 0.8"
                [class.average-score]="agentRouteScore.startTimeCorrectnessScore > 0.6 && agentRouteScore.startTimeCorrectnessScore < 0.8"
                [class.bad-score]="agentRouteScore.startTimeCorrectnessScore <= 0.6">
            {{agentRouteScore.startTimeCorrectnessScore * 100}} %
          </span>
        </div>
        <div *ngIf="agentRouteScore.endTimeCorrectnessScore >=0" class="layout-row layout-align-start-center">
          <span class="primary-100 br-body-2 font-weight-400" translate>End time scoring</span>
          <span class="br-body-1 font-weight-600 margin-left-10"
                [class.good-score]="agentRouteScore.endTimeCorrectnessScore >= 0.8"
                [class.average-score]="agentRouteScore.endTimeCorrectnessScore > 0.6 && agentRouteScore.endTimeCorrectnessScore < 0.8"
                [class.bad-score]="agentRouteScore.endTimeCorrectnessScore <= 0.6">
            {{agentRouteScore.endTimeCorrectnessScore * 100}} %
          </span>
        </div>
        <div *ngIf="agentRouteScore.taskSequenceCorrectnessScore >=0" class="layout-row layout-align-start-center">
          <span class="primary-100 br-body-2 font-weight-400" translate>Correct sequence</span>
          <span class="br-body-1 font-weight-600 margin-left-10"
                [class.good-score]="agentRouteScore.taskSequenceCorrectnessScore >= 0.8"
                [class.average-score]="agentRouteScore.taskSequenceCorrectnessScore > 0.6 && agentRouteScore.taskSequenceCorrectnessScore < 0.8"
                [class.bad-score]="agentRouteScore.taskSequenceCorrectnessScore <= 0.6">
            {{agentRouteScore.taskSequenceCorrectnessScore * 100}} %
          </span>
        </div>
        <hr class="margin-top-10 margin-bottom-10">

        <div *ngIf="agentRouteScore.routeScore >=0" class="layout-row layout-align-start-center">
          <span class="primary-100 br-body-2 font-weight-400" translate>Average score</span>
          <span class="br-body-1 font-weight-600 margin-left-10"
                [class.good-score]="agentRouteScore.routeScore >= 80"
                [class.average-score]="agentRouteScore.routeScore > 60 && agentRouteScore.routeScore < 80"
                [class.bad-score]="agentRouteScore.routeScore <= 60">
            {{agentRouteScore.routeScore}} %
          </span>
        </div>
      </div>
    </ng-template>
  </div>

  <!--Route Score-->
  <div class="td xsmall layout-row layout-align-start-center flex-10 full-height">

    <bringoz-button type="tertiary"
                    size="fit"
                    theme="secondary"
                    (onClick)="viewAgentRoutesPerformanceEvent.emit({agentRef: agentRouteScore.agentReference}); $event.stopPropagation()">
      <span class="br-body-1 font-weight-400 blue-102" translate>Past Week</span>
    </bringoz-button>

  </div>
</div>
